import { useState, useEffect, useRef } from "react";
import { ChevronDown, Check } from "lucide-react";

const SOPS = [
  { path: "/tutorialcounselor",  label: "Counselor Tutorial" },
  { path: "/tutorialsupervisors", label: "Supervisor Tutorial" },
  { path: "/tutorialattendance",  label: "Attendance App Tutorial" },
  { path: "/tutorialbus",         label: "Bus App Tutorial" },
  { path: "/tutorialdining",      label: "Lunch App Tutorial" },
  { path: "/tutorialgames",       label: "Camp Games Tutorial" },
];

export default function SopSwitcher({ current, accent = "slate" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const accentMap = {
    sky:      { btn: "bg-sky-700/40 hover:bg-sky-600/60 border-sky-400/40 text-white", label: "text-sky-100" },
    emerald:  { btn: "bg-emerald-700/40 hover:bg-emerald-600/60 border-emerald-400/40 text-white", label: "text-emerald-100" },
    indigo:   { btn: "bg-indigo-700/40 hover:bg-indigo-600/60 border-indigo-400/40 text-white", label: "text-indigo-100" },
    blue:     { btn: "bg-blue-700/40 hover:bg-blue-600/60 border-blue-400/40 text-white", label: "text-blue-100" },
    amber:    { btn: "bg-amber-700/40 hover:bg-amber-600/60 border-amber-400/40 text-white", label: "text-amber-100" },
    purple:   { btn: "bg-purple-700/40 hover:bg-purple-600/60 border-purple-400/40 text-white", label: "text-purple-100" },
    slate:    { btn: "bg-slate-700/40 hover:bg-slate-600/60 border-slate-400/40 text-white", label: "text-slate-200" },
  };
  const a = accentMap[accent] || accentMap.slate;

  const currentLabel = SOPS.find(s => s.path === current)?.label || current || "Help & Tutorials";

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border text-xs font-semibold transition ${a.btn}`}
        data-testid="sop-switcher-button"
      >
        <span>{currentLabel}</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-56 bg-white rounded-lg shadow-xl border z-50 py-1" data-testid="sop-switcher-menu">
          {SOPS.map(s => {
            const isCurrent = s.path === current;
            return (
              <a
                key={s.path}
                href={s.path}
                className={`flex items-center justify-between gap-2 px-3 py-2 text-xs hover:bg-slate-50 ${isCurrent ? "font-bold text-slate-900 bg-slate-50" : "text-slate-700"}`}
                data-testid={`sop-switcher-link-${s.path.replace("/tutorial", "")}`}
              >
                <span>{s.label}</span>
                {isCurrent && <Check className="w-3.5 h-3.5 text-emerald-600" />}
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}
